
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 500 250"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#1eb53a","d":"M0 0h500v250H0z"}}),_c('path',{attrs:{"fill":"#0099b5","d":"M0 0h500v125H0z"}}),_c('path',{attrs:{"fill":"#ce1126","d":"M0 80h500v90H0z"}}),_c('path',{attrs:{"fill":"#fff","d":"M0 85h500v80H0z"}}),_c('circle',{attrs:{"cx":"70","cy":"40","r":"30","fill":"#fff"}}),_c('circle',{attrs:{"cx":"80","cy":"40","r":"30","fill":"#0099b5"}}),_c('g',{attrs:{"fill":"#fff","transform":"translate(136 64)"}},[_c('g',{attrs:{"id":"e"}},[_c('g',{attrs:{"id":"d"}},[_c('g',{attrs:{"id":"c"}},[_c('g',{attrs:{"id":"b"}},[_c('path',{attrs:{"id":"a","d":"M0-6v6h3","transform":"rotate(18 0 -6)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"scale(-1 1)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(72)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(-72)"}}),_c('use',{attrs:{"xlink:href":"#c","transform":"rotate(144)"}})]),_c('use',{attrs:{"xlink:href":"#d","y":"-24"}}),_c('use',{attrs:{"xlink:href":"#d","y":"-48"}})]),_c('use',{attrs:{"xlink:href":"#e","x":"24"}}),_c('use',{attrs:{"xlink:href":"#e","x":"48"}}),_c('use',{attrs:{"xlink:href":"#d","x":"-48"}}),_c('use',{attrs:{"xlink:href":"#d","x":"-24"}}),_c('use',{attrs:{"xlink:href":"#d","x":"-24","y":"-24"}})])])
          )
        }
      }
    